var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-top",style:(_vm.customStyle),on:{"click":function($event){return _vm.onClickLink()}}},[_c('img',{staticClass:"img",attrs:{"src":_vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }